import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/customs/suspensive',
  validateSearch: (
    search: Record<string, unknown>,
  ): { status?: string; urgency?: string; regime?: string; declaration?: string } => ({
    status: typeof search.status === 'string' ? search.status : undefined,
    urgency: typeof search.urgency === 'string' ? search.urgency : undefined,
    regime: typeof search.regime === 'string' ? search.regime : undefined,
    declaration:
      typeof search.declaration === 'string' && search.declaration.length > 0
        ? search.declaration
        : undefined,
  }),
}).lazy(() => import('./suspensive.lazy').then((d) => d.Route))
